import React from 'react'

const NextArrow = (props) => {
    const {className,style,onClick}=props;
  return (
    <div className={className} style={{...style,display:"flex",borderRadus:"50%",background:"gray",justifyContent:"center",alignItem:"center",padding:'4px'}} onClick={onClick}>

    </div>
  )
}

export default NextArrow